
import React from "react";

// reactstrap components
import { Row, Col, Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import { NavLink } from 'reactstrap';

//React Icons
import {
    FaTwitterSquare, FaLinkedin, FaPhoneAlt,
    FaEnvelopeOpenText, FaInstagram
} from 'react-icons/fa';
import { Fragment } from "react";

function Footer() {

    return (
        <footer className="footer footer-black footer-white">
            <Row className="Footer-Columns">
                <Col className="Col-Left">
                    <h2>Oficinas Centrales</h2>
                    <p className="Footer-Phrase">
                        Parque Empresarial San Fernando
                        Avda. de Castilla, 2
                        28830 San Fernando de Henares (Madrid)
                      <br />
                        <FaPhoneAlt className="Icons-Footer" /> (+34) 91 740 72 50
                     <br />
                        <a href="#"> <FaEnvelopeOpenText className="Icons-Footer" /> comunicacion@oiprocesos.com</a>
                    </p>
                </Col>
                <Col className="Col-Center">
                    <h2>Síguenos en Linkedin</h2>
                    <Row>
                        {/*
                            <a
                                data-placement="bottom"
                                href="#"
                                target="_blank"
                                title="Follow us on Twitter"
                            >
                                <FaTwitterSquare className="Icons-Footer-Social" />
                                <p className="d-lg-none">Twitter</p>
                            </a>
                       */}
                        <a
                            data-placement="bottom"
                            href="https://www.linkedin.com/company/oip-outsourcing-ingenier%C3%ADa-de-procesos/?viewAsMember=true"
                            target="_blank"
                            title="Follow us on LinkedIn"
                        >
                            <FaLinkedin className="Icons-Footer-Social" />
                            <p className="d-lg-none">LinkedIn</p>
                        </a>
                        {/*
                        <a
                            data-placement="bottom"
                            href="#"
                            target="_blank"
                            title="Follow us on Instagram"
                        >
                            <FaInstagram className="Icons-Footer-Social" />
                            <p className="d-lg-none">LinkedIn</p>
                        </a>
                        */}
                    </Row>
                    <Button
                        className="Button-Footer"
                        href="/contacto"
                        color="info"
                        outline
                        type="button">
                        Contáctanos
                    </Button>
                </Col>
            </Row>

            <Row className="Footer-Bottom" style={{ margin: "auto" }}>

                <span className="copyright">
                    © {new Date().getFullYear()},  Outsourcing Ingeniería de Procesos
            </span>

                <nav>
                    <ul style={{ marginBottom: 0 }}>
                        <li>
                            <a
                                href="/aviso-legal"
                                target="_blank">
                                Aviso legal
                            </a>
                        </li>
                        <li>
                            <a
                                href="/politica-privacidad-proteccion-datos"
                                target="_blank">
                                Política de privacidad
                            </a>
                        </li>
                        <li>
                            <a
                                href="/codigo-etico"
                                target="_blank">
                                Código ético
                            </a>
                        </li>
                        <li>
                            <a
                                href="/politica-de-cookies"
                                target="_blank">
                                Cookies
                            </a>
                        </li>
                        <li>
                            <a
                                href="/politicas-de-calidad"
                            >
                                Políticas de calidad
                </a>
                        </li>
                        <li>
                            <Denuncias />
                        </li>
                    </ul>
                </nav>
            </Row>
        </footer>
    );
}
export default Footer;

function Denuncias(props) {
    const [show, setShow] = React.useState(false);

    return (
        <>
           
            <Modal returnFocusAfterClose={true} isOpen={show} onHide={() => { setShow(false) }} style={{ overflow: "hidden" }}>
                <ModalBody style={{ padding: 0, marginBottom: -6 }}>
                    <div style={{ width: 1000 }}></div>

                    <style>
                        {".modal-content {overflow:hidden; height: 100%; display: flex;}"}
                        {".modal-dialog {max-width: calc(100% - 45px); height: calc(100% - 45px);}"}
                    </style>
                    <iframe frameBorder="0" width="100%" height="100%" src="https://docs.google.com/forms/d/e/1FAIpQLSesVGU6EWdhR2iHwX3HrEB0Pwh6Hl0cikUw5f2rmJUQr0nZ0A/viewform?usp=sf_link" />

                </ModalBody>

                <ModalFooter style={{ height: 68 }}>
                    <div style={{ display: "flex", flexDirection: "row", marginTop: 10, width: "calc(100% - 30px)" }}></div>
                    <Button variant="secondary Button-Close-Modal" onClick={(ev) => setShow(false)}>
                        Cerrar
                    </Button>
                </ModalFooter>
            </Modal>
        </>);
}

